import ActionsForm from '@/shared/mixins/actionsForm'
import Announcement from '@/shared/http/repositories/realestate/announcementRepository.js'
import addAnnouncements from '@/views/private/realestate/announcements/components/addAnnouncements/addAnnouncements.js'
import { toast } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ActionsForm],
  name: 'tableAnnouncements',
  data () {
    return {
      title: 'Buscar por Comunicado',
      columns: ['COMUNICADO', 'APLICATIVO', 'EMPREENDIMENTO', 'DATA DE ENVIO', 'RESPONSÁVEL', ''],
      components: {addAnnouncements},
      arrayAnnouncements: [],
      isFilter: false,
      filter: localStoreHelper.gestao.comunicados() || {},
      itemsAnnounce: {
        comunicado: '',
        aplicativo: '',
        empreendimento: '',
        dataEnvio: '',
        dataFim: ''
      },
      comunicadoInfos: {
        aplicativo: 0,
        titulo: '',
        descricao: '',
        destino: 0,
        empreendimentoId: '',
        pdf: [],
        comunicadoPdf: ''
      },
      comunicadoInfoTabela: {},
      keyTableAnnouncements: 0
    }
  },
  methods: {
    verificaLocalStoreHelper () {
      this.isFilter = localStoreHelper.gestao.comunicados() != null ? 1 : false
    },
    onLoad () {
      this.verificaLocalStoreHelper()
      if (this.isFilter) {
        Announcement.GetAnnouncementsByFiltro(this.$refs.tableAnnouncements.pagingLimit, this.$refs.tableAnnouncements.pagingIndex, this.filter)
          .then(res => {
            if (res.status === 200) {
              let newAnnouncementsArray = res.data.data
              let newResponse = res
              this.arrayAnnouncements = newAnnouncementsArray
              this.$refs.tableAnnouncements.LoadAllByData(newResponse)
            }
          })
          .catch(() => {})
        return
      }
      Announcement.GetAll(this.$refs.tableAnnouncements.pagingLimit, this.$refs.tableAnnouncements.pagingIndex)
        .then(res => {
          let newAnnouncementsArray = res.data.data
          let newResponse = res
          this.arrayAnnouncements = newAnnouncementsArray
          this.$refs.tableAnnouncements.LoadAllByData(newResponse)
        })
        .catch(() => {})
    },
    Edit (obj) {
      var objJson = JSON.stringify(obj)
      var newObj = JSON.parse(objJson)
      this.$emit('openAddModal', newObj)
    },
    Delete (id) {
      Announcement.Delete(id)
        .then(Response => {
          if (Response.status === 200) {
            this.arrayAnnouncements = Response.data.data
            this.onLoad()
            toast.success(`Comunicado deletado com sucesso`)
          }
        })
        .catch(() => {})
    },
    searchWithFilter (filter, isFilter) {
      this.isFilter = isFilter
      this.filter = filter
      if (!this.isFilter) {
        this.$refs.tableAnnouncements.pagingIndex = 1
        this.$refs.tableAnnouncements.currentPage = 1
      }
      Announcement.GetAnnouncementsByFiltro(this.$refs.tableAnnouncements.pagingLimit, this.$refs.tableAnnouncements.pagingIndex, filter)
        .then(res => {
          if (res.status === 200) {
            let newAnnouncementsArray = res.data.data
            let newResponse = res
            this.arrayAnnouncements = newAnnouncementsArray
            this.$refs.tableAnnouncements.LoadAllByData(newResponse)
          }
        })
        .catch(() => {})
    },
    onDownloadIncome (id) {
      Announcement.DownloadPDF(id)
        .then(res => {
          if (res.status === 200) {
            let dataResponse = res.data.data
            const linkDownload = document.createElement('a')
            linkDownload.href = `data:image/png;base64,${dataResponse.arquivo}`
            linkDownload.download = `${dataResponse.descricao}.${dataResponse.extensao}`
            linkDownload.click()
            URL.revokeObjectURL(linkDownload.href)
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/announcements/components/tableAnnouncements/tableAnnouncements.js